var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "拟定文档",
        visible: _vm.showDialog,
        "append-to-body": "",
        top: "50px",
        width: "1000px"
      },
      on: {
        "update:visible": function($event) {
          _vm.showDialog = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "div",
            { staticClass: "select-module" },
            [
              _c("span", { staticClass: "lable" }, [_vm._v("选择模板：")]),
              _c(
                "el-select",
                {
                  attrs: { size: "small", placeholder: "请选择" },
                  on: { change: _vm.moduleChange },
                  model: {
                    value: _vm.value,
                    callback: function($$v) {
                      _vm.value = $$v
                    },
                    expression: "value"
                  }
                },
                _vm._l(_vm.newTemplateList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.index }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.showDialog
            ? _c("Cheditor", {
                ref: "cheditor",
                model: {
                  value: _vm.content,
                  callback: function($$v) {
                    _vm.content = $$v
                  },
                  expression: "content"
                }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "btns" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.btnLoading
                  },
                  on: { click: _vm.getContent }
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.openDialog }
                },
                [_vm._v("保存为模板")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "保存模版",
            visible: _vm.showDialog2,
            "append-to-body": "",
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog2 = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.ruleForm,
                size: "small",
                rules: _vm.rules,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模版名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "模式", prop: "isAdd" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.ruleForm.isAdd,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "isAdd", $$v)
                        },
                        expression: "ruleForm.isAdd"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "add" } }, [
                        _vm._v("保存为新模版")
                      ]),
                      _c("el-radio", { attrs: { label: "update" } }, [
                        _vm._v("更新当前模板")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("ruleForm")
                        }
                      }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }